import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { API_CONFIG } from '../config/api.config';
import { UserDeleteRequest, UserResponse, UserUpdateRequest } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly http = inject(HttpClient);

  getMe(): Observable<UserResponse> {
    return this.http.get<UserResponse>(`${API_CONFIG.baseUrl}/users/me`);
  }

  updateUser(id: number, body: UserUpdateRequest): Observable<UserResponse> {
    return this.http.put<UserResponse>(`${API_CONFIG.baseUrl}/users/${id}`, body);
  }

  exportMyData(): Observable<Blob> {
    return this.http.get(`${API_CONFIG.baseUrl}/users/me/export`, {
      responseType: 'blob',
    });
  }

  deleteMe(body: UserDeleteRequest): Observable<void> {
    return this.http.delete<void>(`${API_CONFIG.baseUrl}/users/me`, { body });
  }
}
